import React, {useContext, useState} from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Stack,
  TextField, Toolbar,
  Typography
} from "@mui/material";
import {Link} from "react-router-dom";
import {grey} from "@mui/material/colors";
import {ArrowForwardIos} from "@mui/icons-material";
import {toast} from "react-toastify";
import {SignInContext} from "../../../context/SignInContext";
import {OpenbrainLogoLink} from "../../../components/links/OpenbrainLogoLink";
import {FitrLogoLink} from "../../../components/links/FitrLogoLink";

export const RegisterPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    lastname: "",
    email: "",
    password: "",
  })
  const {onRegister} = useContext(SignInContext);

  const onChange = (e) => {
    const key = e.target.name;
    const value = e.target.value;

    updateForm(key, value);
  }

  const updateForm = (key, value) => {
    setFormData(prev => ({...prev, [key]: value}));
  }

  const registerHandle = async (e) => {
    e.preventDefault();
    if (!formData?.name || !formData?.lastname || !formData?.email || !formData?.password) {
      toast.error("All fields are required")
      return;
    }
    try {
      await onRegister({...formData, username: formData?.email});
    } catch (err) {
      toast.error(err.message);
    }
  }

  return (
    <Grid container sx={{width: "100%", height: "100%", bgcolor: "rgb(255,255,255)"}}>
      <Grid item gap={2} xs={12} justifyContent={"space-between"} className={"bg-primary-gradient"} sx={{display: "flex", flexDirection: "column", height: "100%"}}>
        <Toolbar>
          <img src={"/logo.svg"} alt={"logo"} width={30}/>
        </Toolbar>
        <Stack
          maxWidth={"sm"} direction={"column"} gap={3}
          sx={{maxWidth: "400px", width: "100%", px: 3, py: 5, borderRadius: 4, bgcolor: "#fefefe", mx: "auto"}}
          justifyContent={'center'} alignItems={"center"}
        >
          {/*HEADER*/}
          <Stack direction={"column"} gap={2} sx={{width: '100%'}}>
            {/*TITLE*/}
            <Typography color={"dark.main"} fontSize={50} variant={'h2'} textAlign={"center"}
                        fontWeight={"bold"}>Sign up</Typography>
            {/*SIGN UP*/}

            <Box sx={{textAlign: "center"}}>
              <Typography sx={{color: grey[700]}} component={"span"}>Already have account?</Typography>
              <Link to={"/login"} style={{
                paddingLeft: 5,
                color: "#252525",
                fontWeight: 'bold',
                textDecoration: "none",
                cursor: "pointer"
              }}>
                Sign in
              </Link>
            </Box>
          </Stack>
          {/*LOGIN WITH MAIL*/}
          <Stack component={"form"} onSubmit={registerHandle} direction={"column"} gap={1} sx={{width: '100%'}}>
            <Stack direction={"row"} gap={1}>
              <TextField
                variant={"standard"}
                required
                fullWidth
                label={"Name"}
                value={formData?.name}
                name={"name"}
                onChange={onChange}
                placeholder={"Enter your first name"}
              />
              <TextField
                variant={"standard"}
                required
                fullWidth
                label={"Last name"}
                value={formData?.lastname}
                name={"lastname"}
                onChange={onChange}
                placeholder={"Enter your last name"}
              />
            </Stack>
            <TextField
              variant={"standard"}
              required
              fullWidth
              label={"Email"}
              value={formData?.email}
              name={"email"}
              onChange={onChange}
              placeholder={"Enter your email address"}
            />

            <TextField
              autoFocus
              type={"password"}
              variant={"standard"}
              required
              fullWidth
              name={"password"}
              label={"Password"}
              value={formData?.password}
              placeholder={"Enter your password"}
              onChange={onChange}
            />

            <Stack direction={"row"} gap={2} justifyContent={"space-between"} alignItems={"center"}
                   useFlexGap flexWrap={"wrap"}>
              <FormControlLabel sx={{color: grey[700]}} control={<Checkbox defaultChecked
                                                                           sx={{"&.Mui-checked": {color: "primary.main"}}}/>}
                                label="Remember me"/>
              <Typography sx={{textDecoration: "none", color: grey[700]}} component={Link}
                          to={"/forgot-password"}>Forgot password?</Typography>
            </Stack>
            <Button
              fullWidth
              type={"submit"}
              variant={"modal"}
              disabled={!formData?.name || !formData?.lastname || !formData?.email || !formData?.password}
              sx={{
                textTransform: "capitalize",
                fontWeight: "bold",
              }}
              endIcon={<ArrowForwardIos style={{fontSize: 13}}/>}
            >
              Continue
            </Button>
          </Stack>
        </Stack>
        <Toolbar sx={{justifyContent: "space-between"}}>
          <OpenbrainLogoLink />
          <FitrLogoLink/>
        </Toolbar>
      </Grid>
    </Grid>
  )
}